// Storefront wishlist runtime: event-delegated hearts + add-to-list modal, backed by
// the Spec 2a App-Proxy API. Pure logic is in wishlist-helpers.js; this is DOM/fetch glue.
(function () {
  var CFG = window.WISHLIST_CONFIG || {};
  var H = window.WishlistHelpers;
  var modal = document.getElementById("wl-modal");
  var _pendingConfirm = null; // resolve() of an open confirmDialog, so any hide() resolves it (false = cancel)
  var _lastFocus = null; // element focused before the modal opened, restored on close
  var copy = {
    title: "Save to wishlist", loggedOutBefore: "Please", loggedOutAction: "log in",
    loggedOutAfter: "to use your wishlist.", loading: "Loading…", loadError: "Couldn't load your lists.",
    retry: "Try again", savedInOne: "Saved in 1 list.", savedInMany: "Saved in {{ count }} lists.",
    removeAction: "Remove", emailAlert: "Email me when it's available", alertGradeAriaLabel: "Alert grade",
    newListPlaceholder: "New list name", createAction: "+ Create", saveAction: "Save to list", addingAction: "Adding…",
    confirmTitle: "Are you sure?", cancelAction: "Cancel", deleteAction: "Delete", closeAriaLabel: "Close",
    anyGrade: "Any grade", lowGrade: "Low grade", midGrade: "Mid grade", highGrade: "High grade"
  };
  var schemaPromise = null;

  function interpolate(template, values) {
    values = values || {};
    return String(template).replace(/\{\{\s*([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g, function (token, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : token;
    });
  }
  function applySchema(payload) {
    if (!payload) return;
    if (payload.copy) copy = Object.assign(copy, payload.copy);
    if (payload.style) {
      modal.dataset.wlCards = payload.style.cards || "raised";
      modal.dataset.wlCorners = payload.style.corners || "rounded";
      modal.dataset.wlAccent = payload.style.accent || "red";
    }
    var close = modal.querySelector(".wl-modal__x");
    if (close) close.setAttribute("aria-label", copy.closeAriaLabel);
  }
  function pageSchema() {
    var page = document.getElementById("wishlist-page");
    if (!page) return null;
    try {
      return {
        copy: JSON.parse(page.getAttribute("data-wl-modal-copy") || "{}"),
        style: { cards: page.dataset.wlCards, corners: page.dataset.wlCorners, accent: page.dataset.wlAccent }
      };
    } catch (_) { return null; }
  }
  function loadSchema() {
    var embedded = pageSchema();
    if (embedded) { applySchema(embedded); return Promise.resolve(embedded); }
    if (!schemaPromise) {
      schemaPromise = fetch(CFG.proxyBase + "/wishlist/schema", {
        method: "GET", credentials: "same-origin", headers: { accept: "application/json" }
      }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (payload) { applySchema(payload); return payload; });
    }
    return schemaPromise;
  }

  function api(path, opts) {
    opts = opts || {};
    return fetch(CFG.proxyBase + "/wishlist" + path, {
      method: opts.method || "GET",
      credentials: "same-origin",
      headers: { "content-type": "application/json", accept: "application/json" },
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  // --- heart state + header badge -------------------------------------------
  function refresh(root) {
    root = root || document;
    var els = Array.prototype.slice.call(root.querySelectorAll("[data-wishlist-trigger]"));
    var notifyEls = Array.prototype.slice.call(root.querySelectorAll("[data-wl-notify]"));
    var gids = H.uniqueGids(els.concat(notifyEls).map(function (el) { return el.getAttribute("data-product-gid"); }));
    return api("/check", { method: "POST", body: { productGids: gids } }).then(function (res) {
      var map = (res && res.map) || {};
      var alerts = (res && res.alerts) || {};
      var defaultTier = (res && res.defaultTier) || "ANY";
      els.forEach(function (el) {
        el.classList.toggle("is-saved", H.isSaved(map, el.getAttribute("data-product-gid")));
      });
      Array.prototype.slice.call(root.querySelectorAll("[data-wl-notify]")).forEach(function (n) {
        var a = alerts[n.getAttribute("data-product-gid")] || { alert: false, alertGrade: null };
        var cb = n.querySelector(".wl-notify-toggle");
        var sel = n.querySelector(".wl-notify-grade");
        if (cb) cb.checked = !!a.alert;
        // seed a fresh (un-subscribed) control with the customer's default tier; an existing alert keeps its own grade
        if (sel) sel.value = a.alertGrade || defaultTier;
        n.classList.toggle("is-on", !!a.alert); // drives the "Notifying…" active-state label
      });
      setBadge(res ? res.total : 0, res ? res.totalCapped : false);
      return res;
    });
  }
  // `capped` means the server stopped counting at its cap rather than reading
  // the customer's whole wishlist on every page view — render "99+", not the cap.
  function setBadge(total, capped) {
    var b = document.querySelector("[data-wishlist-count]");
    if (!b) return;
    b.textContent = total > 0 ? (capped ? (total - 1) + "+" : String(total)) : "";
    b.hidden = !(total > 0);
  }

  // --- modal -----------------------------------------------------------------
  function setTitle(t) {
    var el = modal.querySelector("[data-wl-title]");
    if (el) el.textContent = t;
  }
  function openModal(trigger, draft) {
    var body = modal.querySelector(".wl-modal__body");
    setTitle(copy.title);
    body.innerHTML = "<p>" + escapeHtml(copy.loading) + "</p>";
    show();
    var gid = trigger.getAttribute("data-product-gid");
    var issueId = trigger.getAttribute("data-issue-id");
    loadSchema().then(function () {
      setTitle(copy.title);
      if (!CFG.loggedIn) {
        body.innerHTML = '<p>' + escapeHtml(copy.loggedOutBefore) + ' <a href="' + escapeHtml(CFG.accountLoginUrl) + '">' + escapeHtml(copy.loggedOutAction) + '</a> ' + escapeHtml(copy.loggedOutAfter) + '</p>';
        return null;
      }
      body.innerHTML = "<p>" + escapeHtml(copy.loading) + "</p>";
      return Promise.all([api("/lists"), api("/check", { method: "POST", body: { productGids: [gid], includeDetails: true } })]);
    }).then(function (r) {
      if (!r) return;
      if (!r[0] || !r[1]) { // Don't overwrite saved alert preferences when their read failed.
        body.innerHTML = '<p class="wl-error">' + escapeHtml(copy.loadError) + ' <button type="button" class="wl-retry wl-btn">' + escapeHtml(copy.retry) + '</button></p>';
        body.querySelector(".wl-retry").addEventListener("click", function () { openModal(trigger); });
        return;
      }
      var lists = r[0].lists || [];
      var inLists = (r[1] && r[1].map && r[1].map[gid]) || [];
      var defaultTier = (r[1] && r[1].defaultTier) || "ANY";
      if (Object.prototype.hasOwnProperty.call(r[1], "issueId")) issueId = r[1].issueId;
      var listAlerts = (r[1].listAlerts && r[1].listAlerts[gid]) || {};
      var selectedList = draft ? draft.listId : (inLists[0] || (lists[0] && lists[0].id));
      if (draft) listAlerts[draft.listId] = draft;
      body.innerHTML = renderModal(lists, inLists, issueId, defaultTier, selectedList);
      wireModal(trigger, gid, issueId, listAlerts, defaultTier);
    });
  }
  function renderModal(lists, inLists, issueId, defaultTier, selectedList) {
    function gradeOpt(val, label) {
      return '<option value="' + val + '"' + (val === defaultTier ? " selected" : "") + ">" + label + "</option>";
    }
    var radios = lists.map(function (l) {
      return '<label class="wl-pick"><input type="radio" name="wl-list" value="' + l.id + '"' +
        (l.id === selectedList ? " checked" : "") + "> " + escapeHtml(l.name) +
        '<span class="wl-pick-count">' + escapeHtml(l.count) + "</span></label>";
    }).join("");
    var membership = inLists.length
      ? '<p class="wl-member">' + escapeHtml(inLists.length === 1 ? copy.savedInOne : interpolate(copy.savedInMany, { count: inLists.length })) + ' <button type="button" class="wl-remove-all">' + escapeHtml(copy.removeAction) + '</button></p>'
      : "";
    var alertRow = issueId
      ? '<div class="wl-alert-settings"><label class="wl-alert"><input type="checkbox" class="wl-alert-cb" aria-controls="wl-modal-grade"> ' + escapeHtml(copy.emailAlert) + '</label>' +
        '<select id="wl-modal-grade" class="wl-grade-cb" hidden disabled aria-label="' + escapeHtml(copy.alertGradeAriaLabel) + '">' +
        gradeOpt("ANY", escapeHtml(copy.anyGrade)) + gradeOpt("LOW", escapeHtml(copy.lowGrade)) +
        gradeOpt("MID", escapeHtml(copy.midGrade)) + gradeOpt("HIGH", escapeHtml(copy.highGrade)) +
        '</select></div>'
      : "";
    return membership +
      '<div class="wl-lists">' + radios + "</div>" +
      '<div class="wl-newrow"><input type="text" class="wl-newname" placeholder="' + escapeHtml(copy.newListPlaceholder) + '" maxlength="80">' +
      '<button type="button" class="wl-create-btn">' + escapeHtml(copy.createAction) + '</button></div>' +
      alertRow +
      '<button type="button" class="wl-add wl-btn wl-btn--primary wl-btn--block">' + escapeHtml(copy.saveAction) + '</button>';
  }
  function wireModal(trigger, gid, issueId, listAlerts, defaultTier) {
    var body = modal.querySelector(".wl-modal__body");
    var alertCb = body.querySelector(".wl-alert-cb");
    var gradeSel = body.querySelector(".wl-grade-cb");
    var picked = body.querySelector('input[name="wl-list"]:checked');
    var activeList = picked ? picked.value : "";
    function alertChoice() {
      return alertCb ? { alert: alertCb.checked, alertGrade: gradeSel.value }
        : (listAlerts[activeList] || { alert: false });
    }
    function syncGrade() {
      if (!gradeSel) return;
      gradeSel.disabled = !alertCb.checked;
      gradeSel.hidden = !alertCb.checked;
    }
    function restoreAlert() {
      if (!alertCb) return;
      var saved = listAlerts[activeList];
      alertCb.checked = !!(saved && saved.alert);
      gradeSel.value = saved ? (saved.alertGrade || "ANY") : defaultTier;
      syncGrade();
    }
    restoreAlert();
    if (alertCb) alertCb.addEventListener("change", syncGrade);
    body.querySelectorAll('input[name="wl-list"]').forEach(function (radio) {
      radio.addEventListener("change", function () {
        listAlerts[activeList] = alertChoice();
        activeList = radio.value;
        restoreAlert();
      });
    });
    body.querySelector(".wl-create-btn").addEventListener("click", function () {
      var name = body.querySelector(".wl-newname").value.trim();
      if (!name) return;
      var btn = this; btn.disabled = true; // block double-create while the POST is in flight
      api("/lists", { method: "POST", body: { name: name } }).then(function (res) {
        if (res && res.ok) openModal(trigger, Object.assign({}, alertChoice(), { listId: res.list.id }));
        else btn.disabled = false; // re-enable on failure; success re-renders the modal
      });
    });
    body.querySelector(".wl-add").addEventListener("click", function () {
      var picked = body.querySelector('input[name="wl-list"]:checked');
      var choice = alertChoice();
      var payload = { productGid: gid, alert: !!choice.alert };
      if (payload.alert) payload.alertGrade = choice.alertGrade || "ANY";
      if (picked) payload.listId = picked.value;
      if (issueId) payload.issueId = issueId;
      var btn = this;
      btn.disabled = true; // block double-submit; the modal hides once the POST settles
      btn.textContent = copy.addingAction;
      btn.setAttribute("aria-busy", "true");
      trigger.classList.add("is-saved"); // optimistic
      api("/items", { method: "POST", body: payload }).then(function (res) {
        if (!res || !res.ok) trigger.classList.remove("is-saved");
        else { refresh(document); dispatchWishlistSuccess(gid, issueId, "ADD"); }
        hide();
      });
    });
    var rm = body.querySelector(".wl-remove-all");
    if (rm) rm.addEventListener("click", function () {
      var picked = body.querySelector('input[name="wl-list"]:checked');
      if (!picked) return;
      api("/items", { method: "DELETE", body: { listId: picked.value, productGid: gid } }).then(function () {
        trigger.classList.remove("is-saved"); refresh(document); hide();
      });
    });
  }
  // reusable confirm dialog — reuses the modal shell. Resolves true/false.
  function confirmDialog(opts) {
    opts = opts || {};
    return loadSchema().then(function () {
      var body = modal.querySelector(".wl-modal__body");
      setTitle(opts.title || copy.confirmTitle);
      body.innerHTML =
        '<p class="wl-confirm-msg">' + escapeHtml(opts.message || "") + "</p>" +
        '<div class="wl-confirm-actions">' +
        '<button type="button" class="wl-cancel wl-btn">' + escapeHtml(copy.cancelAction) + '</button>' +
        '<button type="button" class="wl-ok wl-btn wl-btn--danger">' + escapeHtml(opts.confirmLabel || copy.deleteAction) + "</button></div>";
      show();
      return new Promise(function (resolve) {
        _pendingConfirm = resolve;
        // clear the pending resolver BEFORE hide() so the button's value wins (hide() won't override it)
        function done(val) { _pendingConfirm = null; hide(); resolve(val); }
        body.querySelector(".wl-cancel").addEventListener("click", function () { done(false); });
        body.querySelector(".wl-ok").addEventListener("click", function () { done(true); });
      });
    });
  }
  function show() {
    if (modal.hidden) _lastFocus = document.activeElement; // only capture on a real open, not a re-render show()
    modal.hidden = false;
    var x = modal.querySelector(".wl-modal__x");
    if (x) x.focus();
  }
  function hide() {
    var wasOpen = !modal.hidden;
    modal.hidden = true;
    if (_pendingConfirm) { var r = _pendingConfirm; _pendingConfirm = null; r(false); } // backdrop/X dismiss = cancel
    if (wasOpen && _lastFocus && _lastFocus.focus) _lastFocus.focus();
    _lastFocus = null;
  }
  // Escape closes the modal (backdrop/X dismiss = cancel, same as data-wl-close)
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !modal.hidden) hide();
  });
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  // narrow success signal for Search Analytics (Task 8): dispatched only after a confirmed
  // successful add-to-list or alert-on API response — never for remove, alert-off, or failure.
  function dispatchWishlistSuccess(gid, issueId, action) {
    var detail = { productGid: gid, action: action };
    if (issueId) detail.issueId = issueId;
    document.dispatchEvent(new CustomEvent("captcan:wishlist-success", { detail: detail }));
  }

  // --- move-to-cart (used by manage page + future surfaces) -----------------
  function addToCart(variantId) {
    return fetch("/cart/add.js", {
      method: "POST", headers: { "content-type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) return null;
      // mirror comic-series: refetch the full cart and fire the theme's cart-count event
      return fetch("/cart.js").then(function (c) { return c.json(); }).then(function (cart) {
        window.dispatchEvent(new CustomEvent("cartcount:update", { detail: cart }));
        return cart;
      });
    }).catch(function () { return null; });
  }

  // --- wiring ----------------------------------------------------------------
  document.addEventListener("click", function (e) {
    var t = e.target.closest && e.target.closest("[data-wishlist-trigger]");
    if (t) { e.preventDefault(); openModal(t); return; }
    if (e.target.closest && e.target.closest("[data-wl-close]")) hide();
  });
  document.addEventListener("change", function (e) {
    var box = e.target.closest && e.target.closest("[data-wl-notify]");
    if (!box) return;
    var gid = box.getAttribute("data-product-gid");
    var issueId = box.getAttribute("data-issue-id");
    var cb = box.querySelector(".wl-notify-toggle");
    var sel = box.querySelector(".wl-notify-grade");
    if (e.target === cb && !cb.checked) {
      box.classList.remove("is-on");
      api("/items", { method: "DELETE", body: { productGid: gid } }); // unsubscribe = remove
      return;
    }
    // toggle-on or grade change while on → upsert the default-list alert
    if (cb && cb.checked) {
      // optimistic active state. Do NOT refresh() here: an immediate /check read-after-write
      // can hit D1 before the alert row is visible and falsely reset the box. refresh() on the
      // next page load reaffirms from the server (consistent by then).
      box.classList.add("is-on");
      // notify = wishlisted: fill the matching heart optimistically (add-only; reload reconciles)
      if (gid) document.querySelectorAll('[data-wishlist-trigger][data-product-gid="' + gid + '"]').forEach(function (h) { h.classList.add("is-saved"); });
      var body = { productGid: gid, alert: true, alertGrade: sel ? sel.value : "ANY" };
      if (issueId) body.issueId = issueId;
      var isToggleOn = e.target === cb; // grade-only changes while already on are not a new ALERT_ON
      api("/items", { method: "POST", body: body }).then(function (res) {
        if (isToggleOn && res && res.ok) dispatchWishlistSuccess(gid, issueId, "ALERT_ON");
      });
    }
  });
  if (document.readyState !== "loading") refresh(document);
  else document.addEventListener("DOMContentLoaded", function () { refresh(document); });

  window.WISHLIST = { refresh: refresh, openModal: openModal, addToCart: addToCart, confirm: confirmDialog };
})();
